import { Metamodel } from '../base/model';
import { Owned } from '../base/named';
import { IAttribute, IModel } from '../base/annotation';

@Metamodel.model({
    name: 'logging-setting'
})
export class LoggingSettings extends Owned {
    public static readonly ENABLE_RELIABLE_LOGGING: IAttribute;
    public static readonly LOG_LEVEL: IAttribute;
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        templatable: true,
        association: 'ENABLE_RELIABLE_LOGGING'
    })
    public enableReliableLogging?: boolean = false;

    @Metamodel.attribute({
        templatable: true,
        association: 'LOG_LEVEL'
    })
    public logLevel?: 'Warning' | 'Info' = 'Warning';
}
